




























import Vue from 'vue';
import Icon from '../Icon/Icon.vue';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  methods: {
    selectCheckbox() {
      this.$emit('input', this.isChecked);
    },
  },
  watch: {
    checked(newValue: boolean) {
      this.isChecked = newValue;
    },
  },
});
